module.exports = __webpack_public_path__ + "img/qr_03.892b2c97.jpg";